import React, { useState } from 'react'
import ComingSoon from '../../../Pages/ComingSoon/ComingSoon'

const Cancelled = () => {
    const [isVisible, setIsVisible] = useState(true);
  return (
    <div><ComingSoon isVisible={isVisible} setIsVisible={setIsVisible}/></div>
  )
}

export default Cancelled